import { render } from "./CustomParticles.vue?vue&type=template&id=039eeb54&scoped=true"
import script from "./CustomParticles.vue?vue&type=script&lang=js"
export * from "./CustomParticles.vue?vue&type=script&lang=js"

import "./CustomParticles.vue?vue&type=style&index=0&id=039eeb54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039eeb54"]])

export default __exports__